import isEmpty from 'lodash/isEmpty';

import { cabinClasses } from '../../../constants/cabinClassesConstants';
import {
  NUMBER_OF_STOPS,
  ONE_DAY_STOPOVER,
  ONE_NIGHT_STOPOVER,
  SHORT_STOPOVER,
  STOPOVER_TYPES,
  TWO_NIGHTS_STOPOVER,
} from '../../../constants/searchFiltersConstants';
import { getAgesOfChildren, getAgesOfInfants } from '../../../utils/format';
import {
  CHILD_AGE_DEFAULT_VALUE,
  MAX_INFANT_AGE,
  MAX_PASSENGERS,
} from '../../../widgets/search-form/constants/passengers';
import { getReturnDate, getReturnTimeOfDay } from './searchUtils';
import { convertDateStringOrTimestamp } from './dateUtils';

const transformRegion = (region) => ({
  iataCode: region.code,
  name: region.name,
  city: region.cityName,
  cityCode: region.cityCode,
  continent: region.continentName,
  continentCode: region.continentCode,
  country: region.countryName,
  countryCode: region.countryCode,
});

const transformRoute = (route) => {
  return {
    origin: transformRegion(route.origin),
    destination: transformRegion(route.destination),
    departureDate: new Date(convertDateStringOrTimestamp(route.departureAt)),
    departureTimeOfDay: route.departureTimeOfDay,
  };
};
export const getChildrenAges = (noOfChildren, childAgeArray) =>
  childAgeArray.slice(0, noOfChildren);

export const transformPassengers = (searchData, isForEditPassenger = false) => {
  const arrayOfChildAges = isForEditPassenger
    ? getChildrenAges(searchData.children, searchData.childrenAges)
    : getAgesOfChildren(searchData.childAges);
  const arrayOfInfantAges = isForEditPassenger
    ? getChildrenAges(searchData.infants, searchData.infantsAges)
    : getAgesOfInfants(searchData.childAges);
  const updatedChildrenAge = isForEditPassenger
    ? arrayOfChildAges
    : [
        ...arrayOfChildAges,
        ...Array(MAX_PASSENGERS - (arrayOfChildAges.length || 0)).fill(CHILD_AGE_DEFAULT_VALUE),
      ];

  const updatedInfantAge = isForEditPassenger
    ? arrayOfInfantAges
    : [
        ...arrayOfInfantAges,
        ...Array(MAX_PASSENGERS - (arrayOfInfantAges.length || 0)).fill(MAX_INFANT_AGE),
      ];
  return {
    adults: searchData.adults,
    children: arrayOfChildAges.length,
    infants: arrayOfInfantAges.length,
    childrenAges: updatedChildrenAge,
    infantsAges: updatedInfantAge,
  };
};

export const transformSearchResultData = (currentSearchData, resultData) => {
  if (isEmpty(resultData)) {
    return null;
  }

  const { routes: searchResultsRoutes, type: tripType } = resultData;

  const [firstRoute] = searchResultsRoutes;

  const singleBound = {
    ...transformRoute(firstRoute),
    returnDate: getReturnDate(tripType, searchResultsRoutes),
    returnTimeOfDay: getReturnTimeOfDay(tripType, searchResultsRoutes),
  };

  const multiBound = searchResultsRoutes.map((route) => transformRoute(route));

  const passengers = transformPassengers(currentSearchData?.travelers);

  const cabinClass = currentSearchData?.cabinClass
    ? cabinClasses[currentSearchData.cabinClass]
    : cabinClasses.ECONOMY;

  return {
    ...resultData,
    cabinClass,
    carrierCodes: currentSearchData.carrierCodes,
    directFlight: currentSearchData?.filters?.[NUMBER_OF_STOPS] === '0',
    destination: {
      ...transformRegion(firstRoute.destination),
      departuredAt: getReturnDate(tripType, searchResultsRoutes),
    },
    origin: {
      ...transformRegion(firstRoute.origin),
      departuredAt: new Date(firstRoute.departureAt),
    },
    passengers,
    stopoverEnabled: Boolean(currentSearchData?.filters?.[STOPOVER_TYPES]),
    shortStopover: Boolean(currentSearchData?.filters?.[STOPOVER_TYPES]?.includes(SHORT_STOPOVER)),
    oneDayStopover: Boolean(
      currentSearchData?.filters?.[STOPOVER_TYPES]?.includes(ONE_DAY_STOPOVER),
    ),
    oneNightStopover: Boolean(
      currentSearchData?.filters?.[STOPOVER_TYPES]?.includes(ONE_NIGHT_STOPOVER),
    ),
    twoNightsStopover: Boolean(
      currentSearchData?.filters?.[STOPOVER_TYPES]?.includes(TWO_NIGHTS_STOPOVER),
    ),
    singleBound,
    multiBound,
    tripType,
  };
};
